import React from 'react';

export const IconFilter: React.FC = () => {
  return (
    <svg
      stroke="currentColor"
      fill="none"
      stroke-width="2"
      viewBox="0 0 24 24"
      stroke-linecap="round"
      stroke-linejoin="round"
      color="#f5f3f7"
      height="24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
    </svg>
  );
};
